// extracted by mini-css-extract-plugin
module.exports = {"modale-container":"Modale_modale-container__1Yj-G","is-active":"Modale_is-active__3rIvy","modale":"Modale_modale__19NKz","close":"Modale_close__FuvQL"};